import forceLogout, { cottonForceDisconnect } from '../helpers/logout';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { kibanaLog } from '../helpers/logger';

import apiClient from '../middleware/apiClient';
import {
  SESSION,
  COTTON_SESSION,
  COTTON_V1_SESSION,
  COTTON_DISCONNECT,
} from '../helpers/apis';

export const GET_SESSION = 'GET_SESSION';
export const GET_SESSION_SUCCESS = 'GET_SESSION_SUCCESS';
export const GET_SESSION_FAILURE = 'GET_SESSION_FAILURE';

function dispatchGetSession(endpoint = SESSION) {
  return {
    type: GET_SESSION,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetSessionSuccess(payload) {
  return {
    type: GET_SESSION_SUCCESS,
    payload,
  };
}

function dispatchGetSessionFailure(error) {
  return {
    type: GET_SESSION_FAILURE,
    payload: error,
  };
}

export const getSession = (useCottonApi = false) => async (dispatch, getState) => {
  try {
    const { isAptV1Enabled } = cottonFlagManager;
    let endpoint = SESSION;
    if (isAptV1Enabled) {
      kibanaLog('apt_v1_session_api_called');
      endpoint = COTTON_V1_SESSION;
    } else if (useCottonApi) {
      endpoint = COTTON_SESSION;
    }

    const response = await dispatch(dispatchGetSession(endpoint)).payload;
    const { session = {} } = response;
    const { auth = {} } = getState();
    if (auth.status && auth.status !== session.status) {
      // If the auth status has changed during the session, then reload the app.
      window.location.reload();
    }
    dispatch(dispatchGetSessionSuccess(response));
    return session;
  } catch (error) {
    dispatch(dispatchGetSessionFailure(error));
    throw error;
  }
};

export const disconnectCottonSession = async () => {
  try {
    await apiClient.fetch(COTTON_DISCONNECT);
  } catch (error) {
    throw error;
  }
};

export const disconnectSessions = () => async () => {
  const { disableRubyApis, isAptV1Enabled } = cottonFlagManager;
  if (disableRubyApis) {
    cottonForceDisconnect({ aptEnabled: isAptV1Enabled });
  } else {
    if (cottonFlagManager.oauthEnabled) {
      await disconnectCottonSession();
    }
    forceLogout({ aptEnabled: isAptV1Enabled });
  }
};
